// @noflow
import {
    BoostRingsContainer,
    BoostRingsInner,
    BoostRingsInnerInner,
    BoostRingsList,
    BoostRingsRing1,
    BoostRingsRing2,
    BoostRingsRing3,
    BoostRingsRing4
} from './styles';

import PropTypes from 'prop-types';
import * as React from 'react';

export default function BoostRings({ mode }) {
    return (
        <BoostRingsContainer>
            <BoostRingsInner>
                <BoostRingsInnerInner>
                    <BoostRingsList>
                        <BoostRingsRing1 mode={mode} />
                        <BoostRingsRing2 mode={mode} />
                        <BoostRingsRing3 mode={mode} />
                        <BoostRingsRing4 mode={mode} />
                    </BoostRingsList>
                </BoostRingsInnerInner>
            </BoostRingsInner>
        </BoostRingsContainer>
    );
}

BoostRings.propTypes = {
    mode: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/widgets/boost-rings/index.js